import React, { useContext } from 'react';
import { Formik, Form, Field, useFormikContext } from 'formik';
import * as Yup from 'yup';
import { Button } from 'primereact/button';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { COGNITIVE_SECTION } from './constants';
import DimensionBasicData from './DimensionBasicData';
import { AccountContext } from '../../components/AccountContext';

const AddCognitiveDimension = () => {
  const currentAccount = useContext(AccountContext);
  const history = useHistory();
  const {
    setFieldValue,
    values: { dimension },
  } = useFormikContext();

  const dimensionValue = dimension.sectionCode === COGNITIVE_SECTION ? dimension : null;

  const initialValues = {
    sectionCode: dimensionValue ? dimensionValue.sectionCode : COGNITIVE_SECTION,
    code: dimensionValue ? dimensionValue.code : '',
    displayName: dimensionValue ? dimensionValue.displayName : '',
    description: dimensionValue ? dimensionValue.description : '',
  };

  const validationSchema = Yup.object({
    code: Yup.string().required(),
    displayName: Yup.string().required(),
    description: Yup.string().required(),
  });

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, formikBag) => {
        formikBag.resetForm();

        setFieldValue('dimension', { ...values });

        history.push(`/accounts/${currentAccount}/add-itembank-assessment-content/add-cognitive-context`);
      }}
    >
      <Form>
        <Field type="hidden" value={COGNITIVE_SECTION} name="sectionCode" />
        <DimensionBasicData />
        <div>
          <FormattedMessage id="actions.next" defaultMessage="Next">
            {(text) => <Button type="submit" label={text} />}
          </FormattedMessage>
          <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
            {(text) => (
              <Button
                type="button"
                onClick={() => history.push(`/accounts/${currentAccount}/dashboard`)}
                className="p-button-secondary"
                label={text}
              />
            )}
          </FormattedMessage>
        </div>
      </Form>
    </Formik>
  );
};

export default AddCognitiveDimension;
